import { Injectable } from '@angular/core';
import { InstanceDeserializer, InstanceSerializer } from '@gametailors/lp-studio-connector';
import {
  LpRidDicteeActivity,
  LpRidLeeslijstActivity,
  LpRIDLettermixActivity,
  LpRIDPasDeRegelToeActivity,
  LpRidWisselklankenActivity,
  LpRidWoordpadActivity,
  LpRidZinlezenActivity,
  LpSchema,
} from '../../../typings/schema';
import { STUDIO_API_DATA_PACKAGE_PROVIDER } from '../../leerplus/rid-game.provider';
import { CodeMockApi } from './code-mock-api';
import { RecommendationsMockApi } from './recommendations-mock-api';

export type THomeworkAssignmentActivity =
  | LpRIDLettermixActivity
  | LpRidWisselklankenActivity
  | LpRIDPasDeRegelToeActivity
  | LpRidWoordpadActivity
  | LpRidDicteeActivity
  | LpRidLeeslijstActivity
  | LpRidZinlezenActivity;

@Injectable({
  providedIn: 'root',
})
export class CockpitMockService {
  public readonly recommendationsApi = new RecommendationsMockApi();
  public readonly codeApi = new CodeMockApi();

  private readonly casDataPackageProvider = STUDIO_API_DATA_PACKAGE_PROVIDER;

  private deserializerPromise: Promise<InstanceDeserializer<LpSchema['all']>> | null = null;
  private getDeserializer(): Promise<InstanceDeserializer<LpSchema['all']>> {
    if (this.deserializerPromise) {
      return this.deserializerPromise;
    }

    const promise = new Promise<InstanceDeserializer<LpSchema['all']>>(async (resolve) => {
      const schema = await this.casDataPackageProvider.getSchema();
      const files = await this.casDataPackageProvider.getFileMetas();
      resolve(new InstanceDeserializer(schema, files));
    });
    this.deserializerPromise = promise;
    return promise;
  }

  public async getHomeworkConfig(id: string): Promise<THomeworkAssignmentActivity[] | undefined> {
    const config = await this.codeApi.getHomeworkConfig(id);
    if (!config) return undefined;

    const deserializer = await this.getDeserializer();
    const deserialized = deserializer.deserializeMany(config) as THomeworkAssignmentActivity[];
    return deserialized;
  }

  public async saveHomeworkConfig(id: string, assignments: THomeworkAssignmentActivity[]): Promise<void> {
    const serializer = new InstanceSerializer();
    const config = assignments.map((a) => serializer.serialize(a));
    await this.codeApi.saveHomeworkConfig(id, config);
  }

  public async generateAssignments() {
    const instances = await this.recommendationsApi.generateRecommendedAssignments();
    const deserializer = await this.getDeserializer();
    return deserializer.deserializeMany(instances) as THomeworkAssignmentActivity[];
  }
}
